import { useSelector } from 'react-redux';
import { selectWorkordersCountByState } from '../services/selectors';

export const useWorkordersCountByState = () => useSelector(selectWorkordersCountByState);
